<svg
  width="23"
  height="32"
  viewBox="0 0 23 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="size"
  [attr.height]="size"
  [ngClass]="class"
>
  <rect x="0.5" y="0.5" width="22" height="31" fill="white" [attr.stroke]="fill"/>
  <rect x="1" y="30" width="21" height="2" [attr.fill]="fill"/>
  <path d="M16.8025 8.1975L15.745 9.255C16.825 10.3425 17.5 11.8425 17.5 13.5C17.5 16.815 14.815 19.5 11.5 19.5C8.185 19.5 5.5 16.815 5.5 13.5C5.5 10.44 7.7875 7.92 10.75 7.5525V9.0675C8.62 9.4275 7 11.2725 7 13.5C7 15.9825 9.0175 18 11.5 18C13.9825 18 16 15.9825 16 13.5C16 12.255 15.4975 11.13 14.68 10.32L13.6225 11.3775C14.1625 11.925 14.5 12.675 14.5 13.5C14.5 15.1575 13.1575 16.5 11.5 16.5C9.8425 16.5 8.5 15.1575 8.5 13.5C8.5 12.105 9.46 10.9425 10.75 10.605V12.21C10.3 12.4725 10 12.945 10 13.5C10 14.325 10.675 15 11.5 15C12.325 15 13 14.325 13 13.5C13 12.945 12.7 12.465 12.25 12.21V6H11.5C7.36 6 4 9.36 4 13.5C4 17.64 7.36 21 11.5 21C15.64 21 19 17.64 19 13.5C19 11.43 18.16 9.555 16.8025 8.1975Z" [attr.fill]="fillAccent"/>
</svg>
